import axios from 'axios';

import type { PricePackArchitectureRequest, PricePackArchitectureResponse } from 'hooks/ppa/useFetchPricePackArchitecture';
import { ppaUrls } from 'config/urls';

/** Cache PPA chart responses so axis-settings previews reopen without refetching. */
export const PPA_CHART_QUERY_STALE_TIME_MS = 5 * 60 * 1000;

export const PPA_AXIS_PREVIEW_QUERY_OPTIONS = {
    staleTime: PPA_CHART_QUERY_STALE_TIME_MS,
    gcTime: PPA_CHART_QUERY_STALE_TIME_MS,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
} as const;

export const getPpaChartQueryKey = (request: PricePackArchitectureRequest) =>
    ['ppa-chart', JSON.stringify(request)] as const;

export const fetchPpaChart = async (
    request: PricePackArchitectureRequest,
    signal?: AbortSignal,
): Promise<PricePackArchitectureResponse> => {
    const response = await axios.post<PricePackArchitectureResponse>(
        ppaUrls.getPricePackArchitectureUrl,
        request,
        { signal },
    );
    return response.data;
};
